/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ChartScale {
    DATE = 'DATE',
    MONTH = 'MONTH',
    YEAR = 'YEAR'
}


export function ChartScaleFromJSON(json: any): ChartScale {
    return ChartScaleFromJSONTyped(json, false);
}

export function ChartScaleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChartScale {
    return json as ChartScale;
}

export function ChartScaleToJSON(value?: ChartScale | null): any {
    return value as any;
}

